module.exports = __webpack_public_path__ + "img/矩形 2625.39c8fdbd.png";